module.exports = __webpack_public_path__ + "static/media/clayton.c194604d.mp4";